import createCachedSelector from 're-reselect';

import { defaultRelevantPhrasesState } from '../../reducers/relevantPhrases';
import {
    CampaignsRelevantPhrasesEditorState,
    RelevantPhrasesState
} from '../../typings/relevantPhrases';
import { State } from '../../typings/state';

export const selectRelevantPhrasesEditorValue = createCachedSelector(
    (state: State) => state.relevantPhrasesEditor,
    (state: State, editorId: string) => editorId,
    (
        editors: CampaignsRelevantPhrasesEditorState,
        editorId: string
    ): RelevantPhrasesState => {
        return editors[editorId] || defaultRelevantPhrasesState;
    }
)((state: State, editorId: string) => editorId);
